export default {
  title: "Manager Dashboard",
  backToAdmin: "Back to Admin Dashboard",
  backToManagerDashboard: "Back to Manager Dashboard",
  allDates: "All dates",
  selectGroups: "Select Groups",
  groups: "Groups",
  noGroups: "No groups available",
  selectGroupsPlaceholder: "Select groups to view",
  searchGroups: "Search groups...",
  noGroupsSelected: "No groups selected",
  noDataAvailable: "No data available",
  loading: "Loading...",
  manager: "Manager",

  infoTitles: {
    members: "Members",
    lessons: "Courses",
    completionPercentage: "Course completion Percentage",
    score: "Course Score",
  },

  tabs: {
    lessons: "Courses",
    members: "Members",
  },

  table: {
    member: "Name",
    name: "Name",
    learningPath: "Learning Path",
    completion: "Completion",
    score: "Score",
    sortBy: "Sort by",
    notStarted: "Not Started",
  },

  members: {
    noMembers: "No members to display",
    emptyStateTitle: "No Members Found",
    emptyStateDescription: "There are no members in the selected groups or no performance data available yet.",
    overallCompletion: "Overall Completion",
    overallScore: "Overall Score",
    pathsProgress: "Paths Progress",
    pathsCompleted: "Completed Paths",
    pathsStarted: "Started Paths",
  },

  insights: {
    title: "Insights",
    membersTab: "Members",
    insightsTab: "Insights",
    problemAreas: "Problem Areas",
    recommendedActions: "Recommended Actions",
    close: "Close",
    noInsights: "Select a member to view insights",
    scoreBreakdown: "Score Breakdown",
    gymShort: "Short Gym",
    gymLong: "Long Gym",
    challenge: "Challenge",
    weight: "Weight",
    games: "games",
    journeyStatus: "Course Status",
    completed: "Completed",
    inProgress: "In Progress",
    noAnalysis: "No analysis available",
    notStarted: "Not started",
    viewDetails: "View Details",
  },

  userDetail: {
    title: "User Performance",
    overallProgress: "Overall Progress",
    noLessons: "No courses available",
    noData: "No data to display",
    assignedLessons: "Assigned Courses",
    noAssignedLessons: "No assigned courses",
    score: "Score",
    completion: "Completion",
    totalTimeSpent: "Total time",
    gyms: "Gyms",
    challenges: "Challenges",
    latestActivity: "Latest Activity",
    noRecentActivity: "No recent activity",
    loadingActivity: "Loading...",
    recentJourneys: "Recent courses",
    recentGames: "Recent Games",
    journeyFallback: "Course #{id}",
    gameFallback: "Game #{id}",
    addNote: "Add note",
    managerNotes: "My Notes",
    noteTextPlaceholder: "Write a note...",
    noNotes: "No notes yet",
    deleteNote: "Delete note",
    cancel: "Cancel",
    completionPercentage: "Completion",
    averageScore: "Average Score",
    averageScoreTooltip: "This is a weighted average score, as each game type has a different weight in the calculation.",
    steps: "Steps",
    chapters: "chapters",
    analysisDetail: "Analysis Detail",
    conversation: "Conversation",
    noMessages: "No messages in this game",
    messageCount: "{count} message | {count} messages",
    lastSignIn: "Last Sign-In",
    latest: "Latest",
    version: "Version",
    startedAt: "Started at",
    playthroughOption: "#{number} - {date}",
    saving: "Saving...",
    collapsePanel: "Collapse panel",
    expandPanel: "Expand panel",

    activityTypes: {
      journey: "journey",
      game: "game",
    },

    activityTime: {
      justNow: "Just now - {type}",
      justNowShort: "Just now",
      minutesAgo: "{minutes} minute ago - {type} | {minutes} minutes ago - {type}",
      minutesAgoShort: "{minutes}m ago",
      hoursAgo: "{hours} hour ago - {type} | {hours} hours ago - {type}",
      hoursAgoShort: "{hours}h ago",
      yesterday: "Yesterday - {type}",
      yesterdayShort: "Yesterday",
      daysAgo: "{days} days ago - {type}",
      daysAgoShort: "{days}d ago",
    },

    tabs: {
      feedback: "Zpětná vazba",
      sales: "Sales",
      coldCalling: "Cold calling",
    },

    pills: {
      feedback: "Category",
      management: "Subcategory",
    },

    table: {
      name: "Name",
      type: "Type",
      status: "Status",
      played: "Played",
      timeSpent: "Time spent",
      lastScored: "Last scored",
    },

    playthrough: "Playthrough",
  },

  emptyState: {
    title: "No Groups Selected",
    description: "Please select one or more groups to view performance data and insights.",
    cta: "Select Groups",
  },

  messages: {
    noData: "No data to display",
    fetchError: "Error fetching data",
    noPermission: "You don't have permission to view this data",
  },

  mutualAgreements: {
    title: "Agreements & Tasks",
    add: "Add",
    createAgreement: "Create Agreement/Task",
    editAgreement: "Edit Agreement/Task",
    viewAgreement: "Agreement/Task Details",
    noAgreements: "No mutual agreements/tasks yet",
    confirmDelete: "Are you sure you want to delete this agreement/task?",
    markComplete: "Mark as fulfilled",
    markIncomplete: "Mark as incomplete",
    fulfilledOn: "Fulfilled on {date}",
    overdue: "⚠ Past due date",
    save: "Save",
    create: "Create",
    saving: "Saving...",
    modalTitle: "Agreement/Task Title",
    status: "Status",
    statusFulfilled: "Fulfilled",
    statusPending: "Pending",

    // Form fields
    titlePlaceholder: "Enter agreement/task title...",
    description: "Description",
    descriptionPlaceholder: "Describe the agreement/task details...",
    dueDate: "Due Date",

    // Priority
    priority: "Priority",
    priorityLow: "Low",
    priorityMedium: "Medium",
    priorityHigh: "High",

    // Categories
    category: "Category",
    categoryGeneral: "General",
    categoryTraining: "Training",
    categoryPerformance: "Performance",
    categoryBehavior: "Behavior",
    categoryGoal: "Goal",
  },
};
